
import { Button } from "@/components/ui/button";
import { useNavigate, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";
import { useEffect } from "react";
import NavigationBar from "@/components/landing/NavigationBar";
import Footer from "@/components/landing/Footer";
import { Helmet } from "react-helmet";

const Terms = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    // Check if we need to scroll to a specific section
    if (location.state && location.state.scrollToId) {
      const element = document.getElementById(location.state.scrollToId);
      if (element) {
        setTimeout(() => {
          element.scrollIntoView({ behavior: 'smooth' });
        }, 100);
      }
    } else {
      // Otherwise scroll to top
      window.scrollTo(0, 0);
    }
  }, [location]);

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <Helmet>
        <meta name="google-site-verification" content="google15216b09c4c3604a" />
      </Helmet>
      
      <NavigationBar />
      
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Button
          variant="ghost"
          onClick={() => navigate(-1)}
          className="mb-6 text-white hover:bg-white/10"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back
        </Button>
        
        <h1 className="text-3xl font-bold mb-8 text-white">Terms of Service</h1>
        
        <div className="space-y-6">
          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">1. Service Usage</h2>
            <p className="text-gray-300 mb-4">
              By using AnalystX, you agree to these terms of service. Our service provides AI-powered market research and analysis tools.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">2. User Responsibilities</h2>
            <p className="text-gray-300 mb-4">
              Users are responsible for maintaining the confidentiality of their account credentials and for all activities under their account.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">3. Data Usage</h2>
            <p className="text-gray-300 mb-4">
              We collect and process data in accordance with our <Link to="/privacy" className="text-blue-400 hover:underline">privacy policy</Link>. Users retain ownership of their uploaded content.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">4. Service Modifications</h2>
            <p className="text-gray-300 mb-4">
              We reserve the right to modify or discontinue any part of our service with reasonable notice to users.
            </p>
          </section>

          <section className="bg-gray-800/30 rounded-xl p-6 border border-gray-700/30">
            <h2 className="text-xl font-semibold mb-4 text-white">Related Policies</h2>
            <p className="text-gray-300 mb-4">
              Please also review our <Link to="/privacy" className="text-blue-400 hover:underline">Privacy Policy</Link>, 
              <Link to="/data-processing" className="text-blue-400 hover:underline"> Data Processing Agreement</Link>, and 
              <Link to="/cookie-policy" className="text-blue-400 hover:underline"> Cookie Policy</Link>.
            </p>
          </section>
        </div>
      </div>
      
      <Footer />
    </div>
  );
};

export default Terms;
